<script setup>
import vector1 from '@/assets/images/bubbles/vector-1.svg';
import vector2 from '@/assets/images/bubbles/vector-2.svg';

defineProps({
  bubble: {
    required: true,
    type: Object,
  },
});
</script>

<template>
  <div class="absolute text-bold z-10 flex text-xs">
    <div>
      <img
        :src="`${bubble.img === 1 ? vector1 : vector2}`"
        alt="bakgrunni"
        class="w-full object-contain h-full absolute"
        :class="[`${bubble.invertX && 'scale-x-[-1]'}`]"
        loading="lazy"
        width="144"
        height="68"
      />
    </div>

    <div class="absolute z-[11] top-1/5 left-1/2 -translate-x-1/2 font-bold">
      <div :class="{ 'w-max': bubble.maxW }">{{ bubble.text }}</div>
    </div>
  </div>
</template>
